/**
 * swiperBannerClick mixin
 *
 * [배경]
 * Swiper loop 모드는 무한 루프를 위해 슬라이드 DOM을 복제하는데,
 * 복제 슬라이드에는 Vue @click.native 이벤트가 바인딩되지 않는다.
 * 결과적으로 to=""인 nuxt-link 클릭 시 현재 페이지가 재로딩되는 버그 발생.
 *
 * [해결]
 * 1. 내부 링크: <nuxt-link :to="url"> — :to에 실제 URL 바인딩으로 href가 DOM에 구워짐
 *    원본 슬라이드: Vue Router가 SPA 이동 처리
 *    복제 슬라이드: href 따라 이동 (정확한 페이지로 이동, 현재 페이지 재로딩 버그 해결)
 * 2. 외부 링크: <a :href="url" target="_blank"> — native 동작 (복제 슬라이드도 href 유지)
 * 3. GTM 트래킹: swiper.on('click') + swiper.realIndex 로 처리
 *    (realIndex는 복제 슬라이드도 실제 데이터 인덱스로 매핑해줌)
 *
 * [사용법]
 * 1. mixins에 추가: mixins: [commonfunc, swiperBannerClick]
 * 2. 템플릿에서 isBannerExternal / getBannerUrl 사용
 * 3. mounted()에서 addSwiperBannerGtm() 호출
 */
export const swiperBannerClick = {
  methods: {
    /**
     * 배너 item에서 이동 URL 반환.
     * item.pcomLinkUrl (신규 DS 포맷) 또는 item.linkUrl (구 포맷) 모두 지원.
     */
    getBannerUrl (item) {
      const url = item.pcomLinkUrl || item.linkUrl || ''
      return typeof this.unescape === 'function' ? this.unescape(url) : url
    },

    /**
     * 새탭 외부 링크 여부 (banrLinkMvmnTyCd === '02')
     */
    isBannerExternal (item) {
      return item.banrLinkMvmnTyCd === '02'
    },

    /**
     * Swiper 인스턴스에 GTM 트래킹용 click 핸들러 등록.
     * loop 복제 슬라이드를 포함한 모든 클릭을 realIndex 기반으로 처리.
     * 네비게이션은 <nuxt-link :to> / <a :href> 에 맡긴다.
     *
     * @param {Object}   swiperInstance - Swiper 인스턴스 (this.$refs.xxx.swiper)
     * @param {Function} getList        - 배너 배열 반환 함수 () => Array
     * @param {Function} onGtm          - GTM/이벤트 콜백 (item, realIndex) => void
     */
    addSwiperBannerGtm (swiperInstance, getList, onGtm) {
      if (!swiperInstance || typeof onGtm !== 'function') { return }

      // Swiper 이벤트 대신 DOM 클릭 이벤트 사용
      const swiperEl = swiperInstance.$el?.[0] || swiperInstance.el
      if (!swiperEl) {
        return
      }

      swiperEl.addEventListener('click', (event) => {
        const targetIndex = swiperInstance.realIndex ?? swiperInstance.activeIndex
        const list = typeof getList === 'function' ? getList() : getList
        const item = list[targetIndex]
        if (item) {
          onGtm(item, targetIndex)
        }
      })
    }
  }
}
